<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconLoadingSmall',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-loading-small', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M18.55 12.085a.728.728 0 0 0 1.445 0L20 12l-.003.21a8 8 0 1 1-8.207-8.207L12 4l-.085.005a.727.727 0 0 0 0 1.445l.085.005-.193.002a6.546 6.546 0 1 0 6.736 6.736l.003-.193z" opacity=".12"/><path d="M12 4a8 8 0 0 1 8 8 .727.727 0 1 1-1.454 0 6.545 6.545 0 0 0-6.545-6.545A.727.727 0 1 1 12 4" opacity=".64"/>
    </template>
  </svg>
</template>